import { KienlongPayClient } from "@/api/kienlong_pay_http_client";
import { EddRequestRepository } from "../EddRequestRepository";
import {
  mapEddRequestModel,
  mapEddRequestDetailModel,
} from "@/adapters/edd_request_adapter";
import { ErrorModel } from "@/models/ErrorModel";
import {
  EddRequestModel,
  EddRequestDetailModel,
  EddRequestStatus,
} from "@/models/EddRequestModel";

export class EddRequestRepositoryImp implements EddRequestRepository {
  private client: KienlongPayClient;

  constructor(kienlongPayClient: KienlongPayClient) {
    this.client = kienlongPayClient;
  }

  public async getEddRequests({
    keyword,
    status,
    page,
    size,
  }: {
    keyword?: string;
    status?: EddRequestStatus;
    page?: number;
    size?: number;
  }): Promise<{
    pageNumber?: number;
    pageSize?: number;
    totalSize?: number;
    totalPage?: number;
    items?: Array<EddRequestModel>;
  }> {
    try {
      const resp = await this.client.amlCaseMonitorController.getEddRequests({
        keyword: keyword,
        status: status,
        page: page,
        size: size,
      });
      if (resp.data.code === 0) {
        return {
          pageNumber: resp.data.data?.pageNumber ?? 0,
          pageSize: resp.data.data?.pageSize ?? 0,
          totalPage: resp.data.data?.totalPage ?? 0,
          totalSize: resp.data.data?.totalSize ?? 0,
          items: resp.data.data?.items?.map((d) => mapEddRequestModel(d)) ?? [],
        };
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async getEddRequestDetail({
    id,
  }: {
    id: string;
  }): Promise<EddRequestDetailModel> {
    try {
      const resp =
        await this.client.amlCaseMonitorController.getEddRequestDetail({
          id: id,
        });
      if (resp.data.code === 0) {
        return mapEddRequestDetailModel(resp.data.data);
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async submitEddInfo({
    eddRequestId,
    detailExplanation,
    documents,
  }: {
    eddRequestId: string;
    detailExplanation: string;
    documents: Array<File>;
  }): Promise<boolean> {
    try {
      const resp = await this.client.amlCaseMonitorController.submitEddInfo({
        eddRequestId: eddRequestId,
        detailExplanation: detailExplanation,
        documents: documents,
      });
      if (resp.data.code === 0) {
        return true;
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }
}
